import DLabGrid from "../DLabGrid/DLabGrid";
import { useRef, useState, useMemo } from "react";
import { useEffect } from "react";
import { valueOrEmpty } from "../../utils/helpers/text";
import { makeIndent } from "../../utils/helpers/makeIndent.ts";
import DATA_MODEL_TABLE from "../../utils/constants/dataModelTable";

const ClusterGridTableAddFlow = ({ meta, data = [] }) => {
  const gridRef = useRef();
  const [dataList, setDataList] = useState([]);

  const overrideCellRender = (key, defaultObj, metaData) => {
    const addObject = metaData.cellRenderer
      ? { cellRenderer: metaData.cellRenderer }
      : { valueFormatter: (params) => valueOrEmpty(params?.data[key] ?? "-", false, "-") };
    return { ...defaultObj, ...addObject };
  };
  const XLKEYS = [
    DATA_MODEL_TABLE.systemStatus.key,
    DATA_MODEL_TABLE.gxpReady.key,
    DATA_MODEL_TABLE.configurationBaseline.key,
    DATA_MODEL_TABLE.configurationDetails.key
  ];

  const XXLKEYS = [DATA_MODEL_TABLE.configurationDetails.key];
  const dLabColumnDef = useMemo(() => {
    let defaultObj;
    let colDef = [];
    for (const key in meta.fields) {
      if (key !== "actions" && key !== "clusterIdentifier") {
        defaultObj = {
          field: key,
          headerName: meta.fields[key].text,
          autoHeight: true,
          minWidth: XXLKEYS.includes(key) ? 400 : XLKEYS.includes(key) ? 265 : 215,
          ...meta.fields[key]
        };
        defaultObj = overrideCellRender(key, defaultObj, meta.fields[key]);
        if (key === "equipmentModel") {
          defaultObj.cellStyle = makeIndent;
        }
        colDef.push(defaultObj);
      }
    }
    return colDef;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meta.fields]);
  useEffect(() => {
    setDataList(() => data);
    // eslint-disable-next-line
  }, [data]);

  let attr = {
    height: "100%",
    rowHeight: 64,
    columnDefs: dLabColumnDef,
    rowData: dataList,
    treeData: true,
    animateRows: true,
    suppressContextMenu: true,
    hiddenByDefault: true,
    suppressRowClickSelection: true
  };

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      resizable: true,
      suppressMenu: true,
      sortable: false,
      minWidth: 200
    };
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      headerName: "",
      maxWidth: 50,
      cellRendererParams: {
        innerRenderer: () => {
          return "";
        },
        suppressCount: true
      },
      pinned: "left"
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDataPath = useMemo(() => {
    return (data) => {
      return data.clusterParent;
    };
  }, []);

  return (
    <DLabGrid
      {...attr}
      pagination={false}
      suppressPaginationPanel={false}
      defaultColDef={defaultColDef}
      gridRef={gridRef}
      autoGroupColumnDef={autoGroupColumnDef}
      getDataPath={getDataPath}
      groupDefaultExpanded={-1}
    />
  );
};

export default ClusterGridTableAddFlow;
